export default __webpack_public_path__ + "static/refer-8d608019f2ec3121d4e7c3c40f0fe773.png";